export default __webpack_public_path__ + "71682d280696d2a70ecfc81444e06160.glb";